import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from 'react-hot-toast';
import smoothscroll from 'smoothscroll-polyfill';

import { LangProvider } from './context/LangContext';
import { ROUTES } from './constants';

import ErrorBoundary   from './components/ui/ErrorBoundary';
import LoadingScreen   from './components/ui/LoadingScreen';
import ScrollProgressBar from './components/ui/ScrollProgressBar';
import BackToTop       from './components/ui/BackToTop';
import Navbar          from './components/layout/Navbar';
import Footer          from './components/layout/Footer';
import ScrollToTop     from './components/layout/ScrollToTop';
import CookieBanner   from './components/ui/CookieBanner';

import Home        from './pages/Home';
import GdprPage    from './pages/GdprPage';
import TermsPage   from './pages/TermsPage';
import NotFoundPage from './pages/NotFoundPage';
import CatalogPage from './pages/CatalogPage';

import './styles/global.css';

export default function App() {
  useEffect(() => { smoothscroll.polyfill(); }, []);

  return (
    <ErrorBoundary>
      <HelmetProvider>
        <LangProvider>
          <LoadingScreen />
          <BrowserRouter>
            <ScrollProgressBar />
            <ScrollToTop />
            <Navbar />

            <Routes>
              <Route path={ROUTES.HOME}    element={<Home />} />
              <Route path={ROUTES.GDPR}    element={<GdprPage />} />
              <Route path={ROUTES.TERMS}   element={<TermsPage />} />
              <Route path={ROUTES.CATALOG} element={<CatalogPage />} />
              <Route path="*"              element={<NotFoundPage />} />
            </Routes>

            <Footer />
            <BackToTop />
            <CookieBanner />

            <Toaster
              position="bottom-right"
              toastOptions={{
                style: {
                  background: '#112240',
                  color: '#c8d6e5',
                  border: '1px solid rgba(255,255,255,0.1)',
                  borderRadius: '10px',
                  fontFamily: 'DM Sans, sans-serif',
                  fontSize: '0.9rem',
                },
                success: { iconTheme: { primary: '#00b4a0', secondary: '#0a1628' } },
                error:   { iconTheme: { primary: '#ef4444', secondary: '#ffffff' } },
              }}
            />
          </BrowserRouter>
        </LangProvider>
      </HelmetProvider>
    </ErrorBoundary>
  );
}
